<style lang="scss" scoped>
.calendar-wrapper{
    width: 465px;
    height: 465px;
    background: url('./../assets/img/group25.svg') no-repeat;
    background-size: contain;
    margin: 0 auto;
    // margin-top: 14px;
    overflow: hidden;
    &-content{
      width:394px;
      height:394px;
      background:rgba(214,82,10,1);
      border-radius:12px;
      margin: 31px auto;
    }
  }
</style>

<template>
  <div class="calendar-wrapper">
    <div class="calendar-wrapper-content">
      <Turntable></Turntable>
    </div>
  </div>
</template>

<script>
import Turntable from './Turntable';
export default {
  components: {
    Turntable
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lotteryTurntable.vue